const locationHost = typeof window !== 'undefined' ? window.location.host : ''
const portalHost = locationHost.split('.').slice(1).join('.')

const startScript = () => {
  const initScript = document.createElement('script')
  let currentUrl = `https://${portalHost}`
  if (locationHost.indexOf('localhost') !== -1) currentUrl = 'https://uat.sk.ru'
  initScript.textContent = `SK.init({ originPath: "${currentUrl}" }); SK.initFooter({ originPath: "${currentUrl}" });`
  document.querySelector('body').prepend(initScript)
}

export const insertHeader = () => {
  if (typeof window === 'undefined') return
  const currentPath = window.location.href
  if (currentPath.search('/new-projects') !== -1) return
  // check if inserted
  const scripts = document.getElementsByTagName('script')
  const newDate = (new Date()).toISOString().split('T')[0].split('-').join('')
  let scriptUrl = `https://menu.${portalHost}/sk-header-menu.bundle.js?${newDate}`
  if (locationHost.indexOf('localhost') !== -1) {
    scriptUrl = `https://menu.uat.sk.ru/sk-header-menu.bundle.js?${newDate}`
  }
  for (let i = 0; i < scripts.length; i += 1) {
    if (scripts[i].src === scriptUrl) {
      startScript()
      return
    }
  }
  // insert menu script
  const component = document.createElement('script')
  component.setAttribute('src', scriptUrl)
  component.async = true
  document.body.prepend(component)
  const style = document.createElement('link')
  style.setAttribute('rel', 'stylesheet')
  if (locationHost.indexOf('localhost') !== -1) {
    style.setAttribute('href', '//uat.sk.ru/static/base/css/new-footer.css')
  } else {
    style.setAttribute('href', `//${portalHost}/static/base/css/new-footer.css`)
  }
  document.head.append(style)
  // insert initialization
  component.onload = () => {
    startScript()
  }
}

export default insertHeader
